import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-user-place .tb-user-info', {
    display: 'inline-block',
    verticalAlign: 'top',
    marginRight: '12px',
    whiteSpace: 'normal',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-user-place .tb-user-info-item-label', {
    paddingRight: '6px',
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
});

cssRule('.tb-user-place .tb-user-info-item-domain', {
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
});

cssRule('.tb-user-place .tb-user-info-item-divider', {
    padding: '0 9px',
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
});

cssRule('.tb-buy-licenses-button', {
    position: 'absolute',
    right: '18px',
    bottom: '8px',
});

